<template>
  <div id="standard" style="width:100%;height: 100%;padding: 20px;background: white;box-sizing:border-box"
    v-loading.fullscreen.lock.body="loading" :element-loading-text="loadingText"
    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <div
      style="height:calc(100% + 12px);background: white;min-width: 360px;float: left;display: flex; flex-direction: column;">
      <el-row style="height: 30px;margin-bottom:15px">
        <el-col :span="24">
          <el-col :span="24" style="text-align: end;">
            <span style="font-size: 20px;float: left;line-height: 30px;">营销项目管理</span>
            <!-- <el-button type="primary" icon="el-icon-download" size="small" @click="openDownloadDialog">导入导出</el-button> -->
            <el-button type="success" icon="el-icon-plus" size="small" @click="openAddDeptDialog"
              style="background: #4EC880;">新增项目</el-button>
          </el-col>
        </el-col>
      </el-row>
      <el-row style="height: 100%;;overflow: hidden;" class="searchInput">
        <el-col :span="24" style="height: 100%;">
          <div style=" border: 1px solid #eee;border-bottom: none">
            <el-input style="padding:5px" class="sWei" placeholder="请输入名称进行快速检索" v-model="filterText"> </el-input>
          </div>
          <el-scrollbar style="height:calc(100% - 50px);border: 1px solid #eee;border-top:none;border-bottom: none">
            <el-tree class="filter-tree" :data="data" @node-click="handleNodeClick" :props="defaultProps" node-key="id"
              :current-node-key="selectNodeKey" :highlight-current="true" :filter-node-method="filterNode"
              :expand-on-click-node="false" :default-expanded-keys="[1, 0]" ref="tree">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span>{{ node.label }}</span>
              </span>
            </el-tree>
          </el-scrollbar>
        </el-col>
      </el-row>
    </div>
    <div style="height: auto;float: right;width: calc(100% - 380px)">
      <el-row>
        <el-col style="display: flex;justify-content: space-between;align-items: center ">
          <div>
            <span style="color: #4a90e2;font-size: 20px">{{ project_name }}</span>
            <span style="color: #4a90e2;font-size: 20px" v-if="project_code">({{ project_code }})</span>
          </div>
          <div>
            <span style="margin-right: 10px;">启用</span>
            <el-switch style="margin-right: 30px;" v-model="projectInfo.status" active-value="ACTIVE"
              inactive-value="INACTIVE" disabled="true" active-color="#13ce66">
            </el-switch>
            <el-button type="warning" size="small"
              style="font-size: 12px;font-weight: bold;background:#FF9901;border-color: #FF9901"
              @click="openEditDialog">
              编辑</el-button>
          </div>
        </el-col>
        <el-col style=" border-bottom: 2px dashed #eee;height: 15px;"></el-col>
      </el-row>
      <el-row style="margin-top:30px" v-if="data[0].children.length > 0 || data[1].children.length > 0">
        <el-col>
          <el-row>
            <el-col :span="12" style="margin-bottom: 40px;">
              <el-col :span="6" style="font-weight:bold;font-size: 14px ">项目编号</el-col>
              <el-col :span="6" style="color: #87909A;font-size: 14px">{{ projectInfo.project_code }}</el-col>
            </el-col>
            <el-col :span="12" style="margin-bottom: 40px;">
              <el-col :span="6" style="font-weight:bold;font-size: 14px ">项目名称</el-col>
              <el-col :span="6" style="color: #87909A;font-size: 14px">{{ projectInfo.project_name }}</el-col>
            </el-col>
            <el-col :span="12" style="margin-bottom: 40px;">
              <el-col :span="6" style="font-weight:bold;font-size: 14px ">委托方</el-col>
              <el-col :span="6" style="color: #87909A;font-size: 14px">{{ projectInfo.client_name }}</el-col>
            </el-col>
            <el-col :span="12" style="margin-bottom: 40px;">
              <el-col :span="6" style="font-weight:bold;font-size: 14px ">外部系统项目ID</el-col>
              <el-col :span="6" style="color: #87909A;font-size: 14px">{{ projectInfo.external_id }}</el-col>
            </el-col>
            <el-col :span="12" style="margin-bottom: 40px;">
              <el-col :span="6" style="font-weight:bold;font-size: 14px ">讲者年度服务场次</el-col>
              <el-col :span="6" style="color: #87909A;font-size: 14px">{{ projectInfo.speaker_annual_limit }}</el-col>
            </el-col>
            <el-col :span="12" style="margin-bottom: 40px;">
              <el-col :span="6" style="font-weight:bold;font-size: 14px ">讲者听众人数比</el-col>
              <el-col :span="6" style="color: #87909A;font-size: 14px">{{ projectInfo.speaker_audience_ratio }}</el-col>
            </el-col>
            <el-col :span="24" style="margin-bottom: 40px;">
              <el-col :span="3" style="font-weight:bold;font-size: 14px ">辖区根节点</el-col>
              <el-col :span="18" style="color: #87909A;font-size: 14px">
                <el-tag  effect="dark" type="warning" style="margin-right: 5px;"
                  v-for="item in projectInfo.territory_name_array">
                  {{ item.territory_name }}
                </el-tag>
              </el-col>
            </el-col>
            <el-col :span="24" style="margin-bottom: 40px;">
              <el-col :span="3" style="font-weight:bold;font-size: 14px ">推广产品</el-col>
              <el-col :span="18" style="color: #87909A;font-size: 14px">
                <el-tag effect="dark" type="warning" style="margin-right: 5px;"
                  v-for="item in projectInfo.product_item_array" :key="item.product_id">
                  {{ item.product_name }}
                </el-tag>
              </el-col>
            </el-col>
            <el-col :span="24" style="margin-bottom: 40px;">
              <el-col :span="3" style="font-weight:bold;font-size: 14px ">说明</el-col>
              <el-col :span="3" style="color: #87909A;font-size: 14px">{{ projectInfo.comments }}</el-col>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <!--        新增-->
    <el-dialog :visible.sync="addDeptDialog" width="1000px" :show-close="false">
      <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between;">
        <span style="color: #3998F7;font-size: 22px;padding-top:5px">添加新项目</span>
        <span>
          <el-button type="primary" @click="submitAdd" size="small">保存</el-button>
          <el-button type="danger" @click="closeAddDeptDialog" size="small">取消</el-button>
        </span>
      </div>
      <el-form label-width="160px" :model="addProjectForm" :rules="rules" ref="addForm" hide-required-asterisk
        id="add_Project">
        <el-row>
          <el-col :span="11">
            <el-form-item label="项目编码" prop="project_code" class="standard_star">
              <el-input v-model="addProjectForm.project_code" placeholder="请输入营销项目编号"
                oninput="value=value.replace(/\W/g,'')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" style="margin-left:60px">
            <el-form-item label="项目名称" prop="project_name" class="standard_star">
              <el-input v-model="addProjectForm.project_name" placeholder="请输入营销项目名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="委托方" prop="client_name">
              <el-input v-model="addProjectForm.client_name" placeholder="请输入委托方"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" style="margin-left:60px">
            <el-form-item label="外部系统项目ID">
              <el-input v-model="addProjectForm.external_id" placeholder="请输入财务或费控系统的项目编号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="讲者年度服务场次" prop="speaker_annual_limit" class="standard_star">
              <el-input v-model="addProjectForm.speaker_annual_limit" placeholder="请填写讲者年度服务场次上限数"
                oninput="value=value.replace(/\D/g,'')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" style="margin-left:60px">
            <el-form-item label="讲者听众人数比" prop="speaker_audience_ratio" class="standard_star">
              <el-input v-model="addProjectForm.speaker_audience_ratio" placeholder="请填写每位讲者至少需要配备的听众人数"
                oninput="value=value.replace(/\D/g,'')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="辖区根节点">
              <el-cascader style="width:  calc(100% + 60px)" v-model="addProjectForm.territory_id"
                :show-all-levels="false" :filterable="true" :options="territory_array" :props="territory_props"
                clearable></el-cascader>
              <!-- <el-select style="width:  calc(100% + 60px)" filterable v-model="addProjectForm.territory_id"
                placeholder="请选择辖区根节点">
                <el-option v-for="item in territory_array" :key="item.territory_id" :label="item.territory_text"
                  :value="item.territory_id"> </el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="推广产品" prop="product_array">
              <el-select style="width:  calc(100% + 60px)" v-model="addProjectForm.product_array" multiple filterable
                placeholder="请选择">
                <el-option v-for="item in productArray" :key="item.product_id" :label="item.product_name"
                  :value="item.product_id"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="备注">
              <el-input type="textarea" :rows="3" style="width:  calc(100% + 60px)" v-model="addProjectForm.comments"
                placeholder="请输入说明信息"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="启用">
              <el-switch style="margin: 0" active-value="ACTIVE" inactive-value="INACTIVE"
                v-model="addProjectForm.status" active-color="#13ce66"> </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="11" style="margin-left:60px">
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <!--        编辑-->
    <el-dialog :visible.sync="editProjectDialog" width="1000px" :show-close="false">
      <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between;">
        <span style="color: #3998F7;font-size: 22px;padding-top:5px">项目详情</span>
        <span>
          <el-button type="primary" @click="submitEdit" size="small">保存</el-button>
          <el-button type="danger" @click="closeEditDeptDialog" size="small">关闭</el-button>
        </span>
      </div>
      <el-form label-width="160px" :model="editProjectForm" :rules="rules" ref="editForm" id="edit_Project"
        hide-required-asterisk>
        <el-row>
          <el-col :span="11">
            <el-form-item label="项目编号" prop="project_code" class="standard_star">
              <el-input v-model="editProjectForm.project_code" placeholder="请输入项目编号"
                oninput="value=value.replace(/\W/g,'')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" style="margin-left:60px">
            <el-form-item label="项目名称" prop="project_name" class="standard_star">
              <el-input v-model="editProjectForm.project_name" placeholder="请输入项目名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="委托方" prop="client_name">
              <el-input v-model="editProjectForm.client_name" placeholder="请输入委托方"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" style="margin-left:60px">

            <el-form-item label="外部系统项目ID">
              <el-input v-model="editProjectForm.external_id" placeholder="请输入财务或费控系统的项目编号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="讲者年度服务场次" prop="speaker_annual_limit" class="standard_star">
              <el-input v-model="editProjectForm.speaker_annual_limit" placeholder="请填写讲者年度服务场次上限数"
                oninput="value=value.replace(/\D/g,'')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" style="margin-left:60px">
            <el-form-item label="讲者听众人数比" prop="speaker_audience_ratio" class="standard_star">
              <el-input v-model="editProjectForm.speaker_audience_ratio" placeholder="请填写每位讲者至少需要配备的听众人数"
                oninput="value=value.replace(/\D/g,'')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="辖区根节点">
              <el-cascader style="width:  calc(100% + 60px)" v-model="editProjectForm.territory_id"
                :show-all-levels="false" :filterable="true" :options="territory_array" :props="territory_props"
                clearable></el-cascader>
              <!-- <el-select style="width:  calc(100% + 60px)" v-model="editProjectForm.territory_id" placeholder="请选择辖区根节点"
                filterable>
                <el-option v-for="item in territory_array" :key="item.territory_id" :label="item.territory_text"
                  :value="item.territory_id"> </el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="推广产品" prop="product_array">
              <el-select style="width:  calc(100% + 60px)" v-model="editProjectForm.product_array" multiple filterable
                placeholder="请选择">
                <el-option v-for="item in productArray" :key="item.product_id" :label="item.product_name"
                  :value="item.product_id"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="备注">
              <el-input type="textarea" style="width:  calc(100% + 60px)" :rows="3" v-model="editProjectForm.comments"
                placeholder="请输入说明信息"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="启用">
              <el-switch style="margin: 0" active-value="ACTIVE" inactive-value="INACTIVE"
                v-model="editProjectForm.status" active-color="#13ce66"> </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="11" style="margin-left:60px">
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import http from "../../APIService/http";
  import { Message } from "element-ui";
  import xlsx from "xlsx";
  import { export_json_to_excel } from "../../vendor/Export2Excel";
  import moment from 'moment'
  export default {
    name: "home",
    data() {
      return {
        currentPage: 1,
        pageSize: 100,
        data: [
          { label: "已启用", children: [] },
          { label: "已停用", children: [] },
        ],
        defaultProps: {
          label: "label",
        },
        territory_props: {
          value: 'territory_id',
          label: 'territory_name',
          checkStrictly: true,
          emitPath: false,
          multiple: true
        },
        filterText: "",
        projectInfo: {},
        project_name: "",
        project_code: "",
        selectNodeKey: "",
        downloadDialog: false,
        addDeptDialog: false,
        editProjectDialog: false,
        dataForm: {},
        productArray: [],
        territory_array: [],
        addProjectForm: {
          project_code: "",
          project_name: "",
          client_name: "",
          product_array: [],
          territory_id: "",
          speaker_annual_limit: "",
          speaker_audience_ratio: "",
          external_id: "",
          territory_id: "",
          status: "ACTIVE",
          comments: "",
        },
        editProjectForm: {},
        file: "",
        fileList: [],
        fileList2: [],
        rules: {
          project_name: [{ required: true, message: "请输入项目名称", trigger: "blur" }],
          project_code: [{ required: true, message: "请输入项目编号", trigger: "blur" }],
          speaker_annual_limit: [{ required: true, message: "请填写讲者年度服务场次上限数", trigger: "blur" }],
          speaker_audience_ratio: [{ required: true, message: "请填写每位讲者至少需要配备的听众人数", trigger: "blur" }],
        },
        loadingText: "",
        loading: false,
      };
    },
    created() {
      this.init();
      this.getProductArray();
      this.getTerritory();
    },
    methods: {
      getTerritory(terrtory_id = "") {
        debugger;
        var user = this.$store.getters.getUser
        let data = {
          user_id: user.user_id,
          tenant_id: user.tenant_id,
          role: user.role,
          territory_id: terrtory_id
        }
        this.loading = true;
        http.post('/crm/territory/getProjectTerritory', data).then(res => {
          debugger;
          this.loading = false;
          if (res.success === true) {

            this.territory_array = res.data;
          } else {

          }
        })
      },
      async getProductArray() {
        try {
          let data = this.$store.getters.getDataInfo;
          data.tenant_id = this.$store.getters.getUser.tenant_id;

          //this.loading = false
          await http.post("/crm/product/getProductByTenantId", data).then((res) => {
            console.log(res, 5555);
            debugger;
            this.productArray = res.data;
          });
        } catch (e) { }
      },
      handleCurrentChange(val) {
        this.errorData = this.errData.slice((val - 1) * this.pageSize, val * this.pageSize);
      },
      async init() {
        const loading = this.$loading({
          lock: true,
          text: "拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });

        try {
          let user = this.$store.getters.getUser;
          let data = {
            tenant_id: user.tenant_id
          };

          await http.post("/crm/project/getProjectByTenantId", data).then((res) => {
            if (res.success) {
              this.data = [
                { id: 1, label: "已启用", children: [] },
                { id: 0, label: "已停用", children: [] },
              ];
              debugger;
              loading.close();
              if (res.data && res.data.length > 0) {
                for (let i = 0; i < res.data.length; i++) {
                  let obj = res.data[i];
                  if (obj.status == "ACTIVE") {
                    this.data[0].children.push(obj);
                  } else {
                    this.data[1].children.push(obj);
                  }
                }
                debugger;
                if (this.data[0].children.length > 0) {
                  this.$nextTick().then(() => {
                    if (this.selectNodeKey) {
                      this.$refs.tree.setCurrentKey(this.selectNodeKey);

                      const firstNode = document.querySelector(".el-tree-node");
                      const firstNode_children = firstNode.querySelector(".el-tree-node__children");
                      setTimeout(() => {
                        const select_node = firstNode_children.getElementsByClassName("is-current")[0];
                        select_node.click();
                      }, 500);
                    } else {
                      const firstNode = document.querySelector(".el-tree-node");
                      const firstNode_children = firstNode.querySelector(".el-tree-node__children");
                      const firstNode_children_children = firstNode_children.querySelector(".el-tree-node");
                      setTimeout(() => {
                        firstNode_children_children.click();
                      }, 100);
                    }
                  });
                } else {
                  this.$nextTick().then(() => {
                    const firstNode = document.getElementsByClassName("is-expanded")[1];
                    const firstNode_children = firstNode.querySelector(".el-tree-node__children");
                    const firstNode_children_children = firstNode_children.querySelector(".el-tree-node");
                    setTimeout(() => {
                      firstNode_children_children.click();
                    }, 100);
                  });
                }
              } else {
                loading.close();
              }
            }
          });
        } catch (e) {
          loading.close();
          Message({
            type: "error",
            message: JSON.stringify(e),
          });
        } finally {
          loading.close();
        }
      },
      async handleNodeClick(data) {
        try {
          if (data.label === "已启用" || data.label === "已停用") {
            this.addUserDis = true;
            return;
          } else {
            let user = this.$store.getters.getUser;
            let obj = {
              tenant_id: user.tenant_id,
              dept_id: data.id,
            };
            this.project_name = data.project_name;
            this.project_code = data.project_code;
            // data.territory_id = data.terrtory_id.split(",")
            this.projectInfo = data;
            console.log(" --- projectInfo --:",data.territory_id.split(","))
            this.projectInfo["territory_id"] = data.territory_id?data.territory_id.split(","):[];
            // this.projectInfo.territory_id = data.territory_id.split(",");
            // await http.post("/wapi/standard/getDeptInfo", obj).then((res) => {
            //   if (res.success) {
            //     this.project_name = data.project_name;
            //     this.project_code = data.project_code;
            //     this.projectInfo = res.data[0];
            //     loading.close();
            //   }
            // });
          }
        } catch (e) {
          return e;
        }
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      openDownloadDialog() {
        this.downloadDialog = true;
      },
      closeDownloadDialog() {
        this.downloadDialog = false;
        this.file = "";
        this.fileList = [];
        this.excelData = [];
        this.$forceUpdate();
      },
      openAddDeptDialog() {
        this.addProjectForm = {
          project_code: "",
          project_name: "",
          territory_id: "",
          sort: "",
          status: "ACTIVE",
          comments: "",
        };
        this.getTerritory();

        this.addDeptDialog = true;
      },
      closeAddDeptDialog() {
        this.$refs["addForm"].resetFields();
        (this.addProjectForm = {
          project_code: "",
          project_name: "",
          sort: "",
          status: "ACTIVE",
          comments: "",
        }),
          (this.addDeptDialog = false);
      },
      openEditDialog() {
        this.editProjectDialog = true;
        this.editProjectForm = this.projectInfo;
        // this.getTerritory(this.editProjectForm.territory_id);
      },
      closeEditDeptDialog() {
        this.$refs["editForm"].resetFields();
        this.editProjectDialog = false;
      },
      submitAdd() {
        this.$refs["addForm"].validate((valid) => {
          if (valid) {
            this.addProject();
          } else {
            // console.log('error submit!!');
            return false;
          }
        });
      },
      async addProject() {
        try {
          const loading = this.$loading({
            lock: true,
            text: "拼命加载中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          let data = {};
          let user = this.$store.getters.getUser;
          data = this.addProjectForm;
          data.user_id = user.user_id;
          data.tenant_id = user.tenant_id;
          debugger;
          await http.post("/crm/project/addProject", data).then((res) => {
            debugger;
            if (res.success) {
              if (res.data.data === "EXIST") {
                loading.close();
                Message({
                  type: "error",
                  message: "项目编码不能重复",
                });
              } else if (res.data.data === "EXIST_NAME") {
                loading.close()
                Message({
                  type: "error",
                  message: "项目名称不能重复",
                });
              } else {
                this.addDeptDialog = false;
                this.selectNodeKey = this.addProjectForm.project_id;
                this.init();
                Message({
                  type: "success",
                  message: "保存成功",
                });
              }
            } else {
              loading.close();
              Message({
                type: "error",
                message: "保存失败",
              });
            }
          });
        } catch (e) {
          return e;
        }
      },
      submitEdit() {
        this.$refs["editForm"].validate((valid) => {
          if (valid) {
            this.editProject();
          } else {
            // console.log('error submit!!');
            return false;
          }
        });
      },
      async editProject() {
        try {
          // const loading = this.$loading({
          //     lock: true,
          //     text: '拼命加载中',
          //     spinner: 'el-icon-loading',
          //     background: 'rgba(0, 0, 0, 0.7)'
          // });

          let data = {};
          let user = this.$store.getters.getUser;
          data = this.editProjectForm;
          data.user_id = user.user_id;
          await http.post("/crm/project/editProject", data).then((res) => {
            debugger;
            if (res.success) {
              console.log(res.data.data)
              if (res.data.data === "EXIST") {
                // loading.close()
                Message({
                  type: "error",
                  message: "项目编码不能重复",
                });
              } if (res.data.data === "EXIST_NAME") {
                loading.close()
                Message({
                  type: "error",
                  message: "项目名称不能重复",
                });
              } else {
                this.editProjectDialog = false;
                this.selectNodeKey = this.editProjectForm.project_id;
                this.init();
                // this.projectInfo = res.data[0]
                // loading.close()
                Message({
                  type: "success",
                  message: "保存成功",
                });
              }
            } else {
              // loading.close()
              Message({
                type: "error",
                message: "保存失败",
              });
            }
          });
        } catch (e) {
          return e;
        }
      },

      async importDataE() {
        if (this.excelData.length === 0) {
          this.$message.error("请选择导入模板！");
          return false;
        }
        this.loading = true;
        this.loadingText = `正在导入数据0%(0/${this.excelData.length - 1})`;
        this.errData = "";
        this.record = [];
        let herder = this.excelData[0];
        let res = await this.importData(herder, this.excelData.slice(1), 0, 500, this.excelData.length - 1);

        if (!res) {
          this.$message.error("导入失败");
          this.loading = false;
          this.loadingText = "拼命加载中";
        } else {
          if (this.record.some((item) => item)) {
            this.$message.success("导入成功");
            this.loadingText = "拼命加载中";
            this.loading = false;
            if (this.errData.length > 0) {
              this.errorDialog = true;
              this.errorData = this.errData.slice(0, 100);
            }
          } else {
            this.$message.error("导入失败");
            this.loading = false;
            this.loadingText = "拼命加载中";
          }
        }
        // if (this.isUpload) {
        //   this.$refs.upload.submit()
        // } else {
        //   Message({
        //     message: '导入模板不能为空',
        //     type: 'error'
        //   })
        // }
      },
      async importData(herder, excelData = [], page = 0, limit = 1000, size = 0) {
        try {
          if (page * limit >= size) {
            return true;
          }
          let data = {
            progressNum: page * limit,
            user_id: this.$store.getters.getUser.user_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
            data: [herder, ...excelData.slice(page * limit, (page + 1) * limit)],
          };

          let response = await http.post("/wapi/excel/importDept", data);
          if (!response) {
            return false;
          }
          if (response.statusCode === 502) {
            return await this.importData(herder, excelData, page, limit, size);
          }
          this.loadingText = "正在导入数据" + (((page + 1) * limit) / size > 1 ? "100%" : ((((page + 1) * limit) / size) * 100).toFixed(0) + "% ");
          let progressText = (page + 1) * limit >= size ? ` (${size} / ${size})` : ` (${(page + 1) * limit} / ${size})`;
          this.loadingText += progressText;

          if (response.success) {
            this.record.push(true);
            if (response.data) {
              if (!this.errData) {
                this.errData = [];
              }
              this.errData = [...this.errData, ...response.data];
            }
          } else {
            this.record.push(false);
          }
          return await this.importData(herder, excelData, page + 1, limit, size);
        } catch (e) {
          return false;
        }
      },

      async getParsingFile(fileName) {
        return new Promise(function (resolve, reject) {
          //定义reader，存放文件读取方法
          let reader = new FileReader();

          //启动函数
          reader.readAsBinaryString(fileName);
          //onload文件读取成功
          reader.onload = function (e) {
            //workbook存放excel的所有基本信息
            let workbook = xlsx.read(e.target.result, { type: "binary" });
            xlsx.onprogress = function (e) { };
            //定义sheetList中存放excel表格的sheet表，就是最下方的tab
            let sheetList = workbook.SheetNames;

            //存放json数组格式的表格数据
            let resultJson = [];
            if (sheetList.length > 1) {
              reject({ status: false, message: "模板错误,不能有1个以上sheet" });
            }
            sheetList.forEach(function (y) {
              let worksheet = workbook.Sheets[y];
              resultJson = xlsx.utils.sheet_to_json(workbook.Sheets[y], { defval: "" });
            });

            if (resultJson.length === 0) {
              resolve({ status: true, data: resultJson });
            }
            //取出表头
            let tableHeader = Object.keys(resultJson[0]);

            //取出表数据
            let importInfo = resultJson.map((item) => {
              return tableHeader.map((v) => item[v]);
            });

            importInfo = [tableHeader, ...importInfo];
            resolve({ status: true, data: importInfo });
          };
          //文件读取失败
          reader.onerror = function (e) {
            reject({ status: false, message: "解析失败" });
          };
        });
      },

      async handleChange(file, fileList) {
        this.loading = true;
        this.$refs.upload.clearFiles();
        this.loadingText = "文件解析中";
        let res = await this.getParsingFile(file.raw);

        setTimeout(() => {
          this.loading = false;
          this.loadingText = "拼命加载中";
        }, 1000);
        if (!res.status) {
          this.$message.error(res.message);
          this.fileList = [];
          return;
        }

        if (res.data.length === 0 || res.data[0].length !== 5 || res.data[0][0].trim() !== "科室编码") {
          this.$message.error("模板错误，请选择正确的模板");
          this.fileList = [];
          return false;
        }
        if (res.data.slice(1).length === 0) {
          this.$message.error("导入数据必须大于0条");
          this.fileList = [];
          return false;
        }
        if (fileList.length !== 0 && res) {
          this.file = file.name;
        }
        this.excelData = res.data;
        // this.file = file.name
        // const nameArr = file.name.split('.')
        // const extension = nameArr[nameArr.length-1] === 'xlsx'
        // const isLt2M = file.size / 1024 / 1024 < 10
        // if (!extension) {
        //   this.file = ''
        //   this.fileList = []
        //   Message({
        //     showClose: true,
        //     message: '上传模板只能是xlsx',
        //     type: 'error'
        //   })
        // }
        // if (!isLt2M) {
        //   this.file = ''
        //   this.fileList = []
        //   Message({
        //     showClose: true,
        //     message: '传模板大小不能超过 10MB',
        //     type: 'error'
        //   })
        // }
        // this.isUpload = true
        // return extension && isLt2M
      },
      async handleSuccess(res, file) {
        const loading = this.$loading({
          lock: true,
          text: "拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        if (res.success) {
          try {
            let data = {
              user_id: this.$store.getters.getUser.user_id,
              tenant_id: this.$store.getters.getUser.tenant_id,
              path: res.data,
            };
            await http.post("/wapi/excel/importDept", data).then((res) => {
              if (res.success) {
                loading.close();
                if (res.data.length == 0) {
                  Message({
                    type: "success",
                    message: "导入成功",
                  });
                  this.downloadDialog = false;
                } else {
                  this.errorDialog = true;
                  this.downloadDialog = false;
                  this.errorData = [...res.data];
                  this.arr = [...res.data];
                }
                this.file = "";
                this.$refs.upload.clearFiles();
                this.$forceUpdate();
                this.init();
              } else {
                this.fileList = [];
                Message({
                  type: "error",
                  message: "导入失败",
                });
              }
              this.loading = false;
            });
          } catch (err) {
            loading.close();
            Message.error("导入失败！");
          }
        } else {
          loading.close();
          Message.error("导入失败！");
        }
      },
      async downloadData() {
        const loading = this.$loading({
          lock: true,
          text: "拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        try {
          let user = this.$store.getters.getUser;
          let data = {
            tenant_id: user.tenant_id,
          };
          await http.post("/wapi/standard/getAllDept", data).then((res) => {
            if (res.success) {
              if (res.data.length > 0) {
                res.data.forEach((item) => {
                  if (item.status == "ACTIVE") {
                    item.status = "是";
                  } else {
                    item.status = "否";
                  }
                });
              }
              this.allDept = res.data;
              this.handleExportData();
              loading.close();
              Message({
                message: "下载成功",
                type: "success",
              });
            } else {
              loading.close();
              Message({
                message: "下载失败",
                type: "error",
              });
            }
          });
        } catch (e) {
          loading.close();
          Message({
            message: "下载失败",
            type: "error",
          });
        }
      },
      handleExportData() {
        try {
          import("@/vendor/Export2Excel").then((excel) => {
            const tHeader = ["科室编码", "科室名称", "排序", "是否启用", "备注"];
            const filterVal = ["project_code", "project_name", "sort", "status", "comments"];
            const list = this.allDept;
            const data = this.formatJson(filterVal, list);
            excel.export_json_to_excel({
              header: tHeader,
              data,
              filename: "标准科室",
              autoWidth: this.autoWidth,
            });
          });
        } catch (err) {
          this.error();
        }
      },
      obj_to_arr(names, data) {
        return data.map((item) => {
          let arr = [];
          names.forEach((name) => {
            arr.push(item[name]);
          });
          return arr;
        });
      },
      downloadError() {
        try {
          this.loading = true;
          let tHeader = ["科室编码", "科室名称", "排序", "是否启用", "备注", "报错信息"];
          let names = ["project_code", "project_name", "sort", "status", "comments", "message"];
          let data = this.obj_to_arr(names, this.errData);
          this.loadingText = `正在下载错误数据0% (0 / ${data.length})`;
          this.downloadErrorExcel(tHeader, data, 0, 20000);
          //错误数据
          this.loading = false;
          this.loadingText = "拼命加载中";
        } catch (err) {
          this.loading = false;
          this.loadingText = "拼命加载中";
          this.$message.error("下载失败！");
        }
        // try {
        //   import('@/vendor/Export2Excel').then(excel => {
        //     const tHeader = ['科室编码','科室名称','排序','是否启用','备注','报错信息']
        //     const filterVal = [
        //       'project_code',
        //       'project_name',
        //       'sort',
        //       'status',
        //       'comments',
        //       'message'
        //     ]
        //     let arr=[...this.arr]
        //     for (var i = 0; i < arr.length; i++) {
        //       let obj = arr[i].message.join(" ")
        //       arr[i].message = obj
        //     }
        //     const list = arr
        //     const data = this.formatJson(filterVal, list)
        //     excel.export_json_to_excel({
        //       header: tHeader,
        //       data,
        //       filename: '报错信息表',
        //       autoWidth: this.autoWidth
        //     })
        //     this.loading = false
        //     this.errorDialog = false
        //   })
        // } catch (err) {
        //   this.loading = false
        //   this.error()
        // }
      },
      downloadErrorExcel(header, data, page = 0, limit = 5000) {
        try {
          if (page * limit >= data.length) {
            return true;
          }

          //错误数据
          let tHeader = header;
          let tData = data.slice(page * limit, (page + 1) * limit);
          export_json_to_excel({
            header: tHeader,
            data: tData,
            filename: "科室导入错误数据" + (!page ? "" : page),
          });
          this.loadingText = `正在下载错误数据0% (${(page + 1) * limit} / ${data.length})`;
          this.downloadErrorExcel(header, data, page + 1, limit);
        } catch (err) {
          this.loading = false;
          this.loadingText = "拼命加载中";
          this.$message.error("下载失败！");
        }
      },

      formatJson(filterVal, jsonData) {
        return jsonData.map((v) => filterVal.map((j) => v[j]));
      },
    },

    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      },
    },
  };
</script>
<style>
  #add_Project .el-tag {
    color: #fff;
    background: #ff9901;
    border: none;
  }

  #add_Project .el-tag.el-tag--info .el-tag__close {
    display: none;
  }

  #edit_Project .el-tag {
    color: #fff;
    background: #ff9901;
    border: none;
  }

  #edit_Project .el-tag.el-tag--info .el-tag__close {
    display: none;
  }
</style>

<style scoped>
  #standard .searchInput>>>.el-input__inner::-webkit-input-placeholder {
    text-align: center;
  }

  .sWei>>>input {
    width: 97%;
    height: 30px;
  }

  #standard>>>.el-tree-node__content span {
    max-width: 240px;
    overflow: hidden;
    margin-left: 10px;
    color: #bbbbbb;
    text-overflow: ellipsis;
    font-size: 12px;
    white-space: nowrap;
  }

  #standard .sWei>>>.el-input__inner {
    background: #eee;
  }

  #standard>>>.el-tree-node__content {
    height: 40px;
  }

  #standard>>>.el-tree-node.is-expanded.is-focusable>.el-tree-node__content {
    background: none;
  }

  #standard>>>.el-tree-node__expand-icon {
    display: none;
  }

  #standard>>>.filter-tree .el-tree-node__children>.el-tree-node>.el-tree-node__content:before {
    content: "";
    display: inline-block;
    background: url("../../assets/images/treeicon.png") no-repeat;
    background-size: 16px;
    width: 16px;
    height: 16px;
    margin: 20px;
  }

  #standard>>>.filter-tree .el-tree-node__children>.el-tree-node>.el-tree-node__content span {
    margin-left: 0;
    font-size: 16px;
    max-width: 240px;
    color: #606266;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  #standard>>>.el-dialog__header {
    border-bottom: 2px dashed #eee;
    padding: 20px 0 10px;
    margin: 0 20px;
  }

  #standard>>>.el-dialog__body {
    padding-top: 20px;
  }

  #standard>>>.el-form-item__label {
    text-align: left;
    font-weight: bold;
    font-size: 16px;
  }

  #standard>>>.standard_star label:after {
    content: "*";
    color: #f56c6c;
    margin-left: 4px;
  }
</style>


// WEBPACK FOOTER //
// src/pages/project/home.vue